"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Mission() {
  const eyebrow = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const heading = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const rule = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const paragraph = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  return <section data-section-id="5692" id="our-mission" className="relative overflow-hidden bg-white py-32 md:py-44 lg:py-56">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center select-none">
        <span className="font-sans font-light leading-none text-slate-900/[0.04]" style={{
        fontSize: "clamp(180px, 36vw, 22vw)"
      }}>
          K
        </span>
      </div>

      <div className="relative mx-auto max-w-[720px] px-6 md:px-8 text-center">
        {}
        <div ref={eyebrow.ref} className="transition-all ease-out" style={{
        transitionDuration: "900ms",
        transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
        transform: eyebrow.isVisible ? "translateY(0)" : "translateY(16px)",
        opacity: eyebrow.isVisible ? 1 : 0
      }}>
          <p className="font-default text-[11px] font-medium uppercase" style={{
          letterSpacing: "0.22em",
          lineHeight: 1
        }}>
            <span className="text-amber-600">II</span>
            <span className="text-slate-500"> {"\u2014"} OUR MISSION</span>
          </p>
        </div>

        {}
        <h2 ref={heading.ref} className="mt-16 font-default font-semibold text-slate-900 transition-all ease-out" style={{
        fontSize: "clamp(2rem, 4vw, 3.5rem)",
        letterSpacing: "-0.018em",
        lineHeight: 1.08,
        transitionDuration: "900ms",
        transitionDelay: "120ms",
        transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
        transform: heading.isVisible ? "translateY(0)" : "translateY(16px)",
        opacity: heading.isVisible ? 1 : 0
      }}>
          <span className="block">Connecting global</span>
          <span className="block font-medium text-blue-900">textile markets.</span>
        </h2>

        {}
        <div ref={rule.ref} className="mt-14 flex justify-center transition-all ease-out" style={{
        transitionDuration: "900ms",
        transitionDelay: "240ms",
        transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
        transform: rule.isVisible ? "translateY(0)" : "translateY(16px)",
        opacity: rule.isVisible ? 1 : 0
      }}>
          <div className="relative flex items-center" style={{
          width: "64px"
        }}>
            <div className="w-full" style={{
            height: "1px",
            backgroundColor: "hsl(220 6% 28% / 0.15)"
          }} />
            <span aria-hidden="true" className="absolute right-0 bg-amber-600" style={{
            width: "3px",
            height: "3px"
          }} />
          </div>
        </div>

        {}
        <p ref={paragraph.ref} className="mt-14 font-default text-slate-700 transition-all ease-out" style={{
        fontSize: "clamp(1rem, 1.05vw, 1.0625rem)",
        lineHeight: 1.7,
        letterSpacing: "0.005em",
        transitionDuration: "900ms",
        transitionDelay: "360ms",
        transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
        transform: paragraph.isVisible ? "translateY(0)" : "translateY(16px)",
        opacity: paragraph.isVisible ? 1 : 0
      }}>
          At KTEX, we bridge the gap between global textile suppliers and buyers through a transparent, efficient, and secure digital marketplace. Our mission is to simplify the complexities of international trade, ensuring that every transaction is backed by reliability, quality assurance, and a commitment to sustainable growth for all our partners in the textile industry.
        </p>
      </div>
    </section>;
}